export var HTTP_STATUS = {
    TOO_MANY_REQUEST: 429,
    LOOP_DETECTED: 508
};
export var Languages = {
    tr: 'TUR',
    en: 'ENG',
    de: 'DE',
    nl: 'NL',
    bg: 'BG',
    ar: 'AR',
};
export var Flag = {
    tr: 'turkey',
    en: 'united_kingdom',
    de: 'germany',
    nl: 'netherlands',
    bg: 'bulgaria',
    ar: 'saudi_arabia',
};
